import type {HTMLChakraProps} from '@linx-security/ui';
import {Box} from '@linx-security/ui';
import type {ImageProps, StaticImageData} from 'next/image';
import Image from 'next/image';

type Props = Omit<ImageProps, 'src'> & {
  srcLight: StaticImageData;
  srcDark: StaticImageData;
} & Pick<HTMLChakraProps<'div'>, 'flexBasis'>;

/**
 * ThemeImage component renders an image according to the current color mode.
 */
export const ThemeImage = (props: Props) => {
  const {srcLight, srcDark, flexBasis, style, ...rest} = props;

  // Filter out blur properties from static image data to prevent them from being passed to DOM
  const {blurWidth: _lightBlurWidth, blurHeight: _lightBlurHeight, ...cleanSrcLight} = srcLight;
  const {blurWidth: _darkBlurWidth, blurHeight: _darkBlurHeight, ...cleanSrcDark} = srcDark;

  // Merge styles to maintain aspect ratio when dimensions are modified
  const imageStyle = {
    width: 'auto',
    height: 'auto',
    ...style,
  };

  return (
    <Box
      sx={{
        flexBasis,
        '.img-dark': {
          display: `none`,
        },
        '.img-light, .img-dark': {
          width: 'auto',
          height: 'auto',
        },
        _dark: {
          '.img-light': {
            display: `none`,
          },
          '.img-dark': {
            display: `unset`,
          },
        },
      }}
    >
      <Image {...cleanSrcLight} {...rest} style={imageStyle} className={`img-light`} alt={`image-light`} />
      <Image {...cleanSrcDark} {...rest} style={imageStyle} className={`img-dark`} alt={`image-dark`} />
    </Box>
  );
};
